<script setup lang="ts">
import { computed } from 'vue'
import AccountPanelVerificationSteps, { VerificationStep } from '../../AccountPanelVerificationSteps.vue'
import { i18n } from '../../../../localization'
import AccountKycProcessStatusIDNow from './AccountKycProcessStatusIDNow.vue'
import AccountKycProcessStatusSignteq from './AccountKycProcessStatusSignteq.vue'
import { usePersonalAccountDataState } from '../../../../utilities/account/useAccountDataPersonal'
import { KycProvider } from '../../../../utilities/api'

const state = usePersonalAccountDataState()

const steps: VerificationStep[] = [
    {
        name: i18n.global.t('verification.complete_data'),
        description: i18n.global.t('verification.complete_data_description'),
        status: computed(() => {
            return state.hasAllRequiredNaturalProfileAttributesForInvestment ? 'complete' : 'current'
        }),
    },
    {
        name: i18n.global.t('verification.kyc_process'),
        description: i18n.global.t('verification.kyc_process_description'),
        component:
            state.naturalProfile.platform_kyc_provider === KycProvider.IDNOW
                ? AccountKycProcessStatusIDNow
                : AccountKycProcessStatusSignteq,
        status: computed(() => {
            if (
                state.naturalProfile.kyc_id ||
                (state.hasAllRequiredNaturalProfileAttributesForInvestment && state.naturalProfile.external_kyc_done)
            ) {
                return 'complete'
                // if (state.naturalProfile.kyc_id) {
                //     return 'complete'
                // } else {
                //     return 'current'
                // }
            } else if (
                state.hasAllRequiredNaturalProfileAttributesForInvestment &&
                !state.naturalProfile.external_kyc_done
            ) {
                return 'current'
            } else {
                return 'upcoming'
            }
        }),
    },
    {
        name: i18n.global.t('verification.wallet_creation'),
        description: i18n.global.t('verification.wallet_creation_description'),
        status: computed(() => {
            if (
                state.hasAllRequiredNaturalProfileAttributesForInvestment &&
                state.naturalProfile.external_kyc_done &&
                !state.naturalProfile.kyc_id
            ) {
                return 'current'
            } else if (state.naturalProfile.kyc_id) {
                return 'complete'
            } else {
                return 'upcoming'
            }
        }),
    },
    {
        name: i18n.global.t('verification.verification_successful'),
        description: i18n.global.t('verification.verification_successful_description'),
        status: computed(() => {
            if (state.naturalProfile.kyc_id) {
                return 'complete'
            } else {
                return 'upcoming'
            }
        }),
    },
]
</script>

<template>
    <AccountPanelVerificationSteps :steps="steps" class="mt-4" />
</template>
